/**
 * @generated SignedSource<<9287d705db4829e9857fdb166c1d1aa9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
export type CompetitionAcceptRulesButtonMutation$variables = {
  competition: string;
};
export type CompetitionAcceptRulesButtonMutation$data = {
  readonly agreeToCompetitionRule: {
    readonly competitionRule: {
      readonly competition: {
        readonly entityRuleAgreements: {
          readonly edges: ReadonlyArray<{
            readonly cursor: string;
          }>;
        };
        readonly id: string;
        readonly latestRule: {
          readonly entityAgreement: {
            readonly createdAt: DateTime;
            readonly id: string;
          } | null | undefined;
          readonly id: string;
        };
      };
    };
    readonly createdAt: DateTime;
    readonly id: string;
  };
};
export type CompetitionAcceptRulesButtonMutation = {
  response: CompetitionAcceptRulesButtonMutation$data;
  variables: CompetitionAcceptRulesButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "competition"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "competition",
    "variableName": "competition"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Competition",
  "kind": "LinkedField",
  "name": "competition",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CompetitionRule",
      "kind": "LinkedField",
      "name": "latestRule",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "CompetitionRuleAgreement",
          "kind": "LinkedField",
          "name": "entityAgreement",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v3/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        },
        {
          "kind": "Literal",
          "name": "latest",
          "value": true
        }
      ],
      "concreteType": "CompetitionRuleAgreementConnection",
      "kind": "LinkedField",
      "name": "entityRuleAgreements",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompetitionRuleAgreementEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "entityRuleAgreements(first:1,latest:true)"
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionAcceptRulesButtonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CompetitionRuleAgreement",
        "kind": "LinkedField",
        "name": "agreeToCompetitionRule",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CompetitionRule",
            "kind": "LinkedField",
            "name": "competitionRule",
            "plural": false,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "CompetitionAcceptRulesButtonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CompetitionRuleAgreement",
        "kind": "LinkedField",
        "name": "agreeToCompetitionRule",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CompetitionRule",
            "kind": "LinkedField",
            "name": "competitionRule",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ec0937f4a7b7559eca2f3e63b26c0ea5",
    "id": null,
    "metadata": {},
    "name": "CompetitionAcceptRulesButtonMutation",
    "operationKind": "mutation",
    "text": "mutation CompetitionAcceptRulesButtonMutation(\n  $competition: ID!\n) {\n  agreeToCompetitionRule(competition: $competition) {\n    id\n    createdAt\n    competitionRule {\n      competition {\n        id\n        latestRule {\n          id\n          entityAgreement {\n            id\n            createdAt\n          }\n        }\n        entityRuleAgreements(first: 1, latest: true) {\n          edges {\n            cursor\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d0a6b5c6dfeb6b6cc7502b2f0d6b294e";

export default node;
